import AdminHomePage from "./AdminHomePage";

export default AdminHomePage;
